import React from 'react'
import NavLink from '../Routes/NavLink'

import NotificationsTable from '../Notifications/NotificationsTable'
import WorkOrdersWidget from '../WorkOrders/WorkOrdersWidget'
import WorkOrdersNewRequestCard from '../WorkOrders/WorkOrdersNewRequestCard'
import CommunityBoard from '../Tenants/CommunityBoard'
import BuildingLastEditedWidget from '../Building/BuildingLastEditedWidget'
import AllBuildingStatsWidget from '../Buildings/AllBuildingStatsWidget'
import FinancialBreakdownWidget from '../Financial/FinancialBreakdownWidget'
import ExpiringLeasesWidget from '../Leases/ExpiringLeasesWidget'
import ExpiringLeasesCard from '../Leases/ExpiringLeasesCard'
import VacantLeasesCard from '../Leases/VacantLeasesCard'
import SpacesStatCard from '../Spaces/SpacesStatCard'
import CalendarWidget from '../Calendar/CalendarWiget'
import BasicStatsWidget from '../Reports/BasicStatsWidget'
import TenantsLateOnRentTallyCard from '../Tenants/TenantsLateOnRentTallyCard'
import FollowUpLeadsCard from '../Leads/FollowUpLeadsCard'
import LatePaymentsWidget from '../Billing/LatePaymentsWidget'
import DashboardShortcutsWidget from '../Shortcuts/DashboardShortcutsWidget'
import RentProgressWidget from '../Widgets/RentProgressWidget'

export default class CommercialPropertyManagerDashboard extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    componentWillUpdate(nextProps, nextState) {
    }

    render(){
        return (
            <div class="dashboard">
                <div class="row">
                    <WorkOrdersNewRequestCard clickable={true}/>
                    <ExpiringLeasesCard clickable={true}/>
                    <VacantLeasesCard clickable={true}/>
                    {/* <TenantsLateOnRentTallyCard /> */}
                    <FollowUpLeadsCard followUp={"follow_up"} clickable={true}/>
                </div>
                <div class="row">
                    <div class="col-md-8 col-sm-12 col-xs-12">
                        <WorkOrdersWidget/>
                        <LatePaymentsWidget />
                    </div>
                    <div class="col-md-4 col-sm-12 col-xs-12">
                        <DashboardShortcutsWidget />
                        <RentProgressWidget />
                        <CalendarWidget />
                    </div>
                </div>
            </div>
        )
    }
};



// WEBPACK FOOTER //
// app/components/Dashboards/CommercialPropertyManagerDashboard.jsx